import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { getTranslate } from 'react-localize-redux';

import { Result } from '../../Api';
import * as Store from '../../Store';

// ! deprecated - use AxiosError in src/core/types/data.types.ts
export interface AxiosError extends Error {
  config: AxiosRequestConfig;
  code?: number;
  request?: any;
  response?: AxiosResponse<Result<any>>;
}

export default axios;
export * from 'axios';

// ! deprecated - use getUserMessage in src/core/api/apiUtils.ts
export const getErrorMessage = (error: AxiosError): string => {
  const isDev = process.env.REACT_APP_ENVIRONMENT !== 'production';

  const storeInstance = Store.getStoreInstance();
  const state = storeInstance.getState();
  const translate = getTranslate(state.locale);

  const defaultMessage = translate('Unexpected_error_occurred') as string;

  if (error && error.response && error.response.data) {
    if (error.response.data.UserMessage) {
      return error.response.data.UserMessage;
    }

    if (error.response.data.DeveloperMessage) {
      const developerErrorMessage = isDev
        ? `${defaultMessage}: ${error.response.data.DeveloperMessage}`
        : error.response.data.DeveloperMessage;
      return developerErrorMessage;
    }
  }

  return defaultMessage;
};

// ! deprecated - use getUserMessage in src/core/api/apiUtils.ts
export function throwIfServerError(error: AxiosError): void {
  const newError = new Error();

  Object.assign(newError, {
    message: getErrorMessage(error),
    code: error?.response?.data?.Code,
  });

  throw newError;
}

export const apiServices = {
  getErrorMessage,
  throwIfServerError,
};
